import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export interface KalTableEventParameter {
    emitEvent?: boolean;
}

export class KalTableEventManager<T> {
    protected readonly changeSubject = new Subject<T>();
    readonly change$ = this.changeSubject.asObservable().pipe(shareReplay());

    constructor(private _value: T = null) {
    }

    get value() {
        return this.get();
    }

    get() {
        return this._value;
    }

    set(value: T, {emitEvent}: KalTableEventParameter = {}) {
        emitEvent = emitEvent ?? true;
        this._value = value;
        if (emitEvent) {
            this.changeSubject.next(value);
        }
    }

    patch(value: T, event: KalTableEventParameter = {}) {
        this.set({...this._value, ...value}, event);
    }

    close() {
        this.changeSubject.complete();
    }
}
